import { render, staticRenderFns } from "./mix.vue?vue&type=template&id=3107b2fc&scoped=true"
import script from "./mix.vue?vue&type=script&lang=js"
export * from "./mix.vue?vue&type=script&lang=js"
import style0 from "./mix.vue?vue&type=style&index=0&id=3107b2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3107b2fc",
  null
  
)

export default component.exports